import { render, staticRenderFns } from "./ItemReturnReasons.vue?vue&type=template&id=7b494857&"
import script from "./ItemReturnReasons.vue?vue&type=script&lang=js&"
export * from "./ItemReturnReasons.vue?vue&type=script&lang=js&"
import style0 from "./ItemReturnReasons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b494857')) {
      api.createRecord('7b494857', component.options)
    } else {
      api.reload('7b494857', component.options)
    }
    module.hot.accept("./ItemReturnReasons.vue?vue&type=template&id=7b494857&", function () {
      api.rerender('7b494857', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ItemReturnReasons.vue"
export default component.exports